@if (detail?.operation_type_name === OPERATION_TYPE.POL) {
    <tec-info-group>
        <b>{{ 'OPERATIONS.DETAIL.CAPTURE_METHOD' | translate }}</b>
        <tec-tag [label]="captureModeTranslationKey | translate" />
    </tec-info-group>
}

@if (detail?.operation_type_name === OPERATION_TYPE.OCR) {
    <tec-info-group>
        <b>{{ 'PROCESSES.DETAIL.TYPE' | translate }}</b>
        <span>
            {{
                detail?.doc_type
                    ? masterService.getDocumentTypeLabel(detail?.doc_type)
                    : ('GENERAL.NOT_AVAILABLE' | translate)
            }}
        </span>
    </tec-info-group>
}

@if (isFinancialEvaluationOperation()) {
    <tec-info-group>
        <b>{{ 'PROCESSES.DETAIL.TYPE' | translate }}</b>
        <span>{{ financialEvaluationTypeLabel() }}</span>
    </tec-info-group>
}

@if (isTfaOperation()) {
    <tec-info-group>
        <b>{{ 'OPERATIONS.DETAIL.MESSAGING.CHANNEL' | translate }}</b>
        <span>{{ tfaChannelDisplayLabel() }}</span>
    </tec-info-group>
}

@if (isBormeOperation()) {
    <tec-info-group>
        <b>{{ 'OPERATIONS.DETAIL.BORME.TAX_ID' | translate }}</b>
        <span>{{ bormeTaxIdLabel() }}</span>
    </tec-info-group>
    <tec-info-group>
        <b>{{ 'OPERATIONS.DETAIL.BORME.COMPANY_NAME' | translate }}</b>
        <span>{{ bormeCompanyNameLabel() }}</span>
    </tec-info-group>
}
